import { SaleOrderUpdationBillingAddressRequest, updateSOBillingAddressAPI } from '../../api/smartbestbuys-api'

export const updateSOBillingAddress = (saleOrderId: number, billingAddressId: number) => {
  const request: SaleOrderUpdationBillingAddressRequest = {
    billingAddressId,
  }

  return updateSOBillingAddressAPI(saleOrderId, request)
}
